import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { config } from '../config';

/** The Cognito user pool (no Amplify). Tokens are cached in localStorage by the SDK. */
export const userPool = new CognitoUserPool({
  UserPoolId: config.userPoolId,
  ClientId: config.userPoolClientId,
});
